import PropTypes from 'prop-types';
import React from 'react';
import { StyledFormLabel } from './StyledComponents';

/**
 * FormLabel - A simple label component for forms
 *
 * @param {React.ReactNode} children - The label content
 */
const FormLabel = ({ children, ...props }) => {
  return <StyledFormLabel {...props}>{children}</StyledFormLabel>;
};

FormLabel.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FormLabel;
